import useQuery from "app/game-data/useQuery";

const DAILY_GAME_QUERY = /* GraphQL */ `
  query DAILY_GAME {
    contents(gameId: "spellcheck") {
      id
      publishDate
    }
  }
`;

interface DailyGameQueryResponseType {
  contents: {
    id: number;
    publishDate: string;
  }[];
}

export default function useDailyGameId() {
  const { data } = useQuery<DailyGameQueryResponseType>({
    query: DAILY_GAME_QUERY,
  });

  return data?.contents[0].id;
}
